<template>
  <div>
    <transition name="slide-fade">
      <div v-if="mostrarComponentPrincipal" :key="1">
         <FormCreate/>
      </div>
    </transition>

  </div>
</template>

  
<script>
  import FormCreate from '../usuarios/create/FormCreate'

  export default {
    name: 'CreateUsuario',
    components: {
      FormCreate
    },
    setup() {
      return {
        mostrarComponentPrincipal: true,
      };
    },
  }
</script>